import React from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import RichContent from "@/components/RichContent";
import usePageContent, { s, list } from "@/hooks/usePageContent";
import { parseLocaleFromPath } from "@/lib/locale";

export default function HowItsMade() {
  const { locale } = parseLocaleFromPath(useLocation().pathname);
  const { data: page } = usePageContent("how-its-made", locale);
  const steps = list(page, "steps");

  return (
    <>
      <SEO title={page?.meta_title} description={page?.meta_description} />
      <article className="bg-background">
        <section className="relative bg-tz-espresso text-tz-cream overflow-hidden">
          <img src="/seed/wood_materials.webp" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-tr from-tz-espresso via-tz-espresso/85 to-tz-espresso/60" />
          <div className="relative max-w-5xl mx-auto px-5 lg:px-10 py-20 lg:py-28">
            <div className="text-[11px] uppercase tracking-[0.3em] text-primary mb-4">{s(page, "eyebrow")}</div>
            <h1 className="font-serif text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl">
              {s(page, "title")}
            </h1>
            <p className="mt-6 text-lg text-tz-cream/75 max-w-2xl">{s(page, "subtitle")}</p>
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-5 lg:px-10 py-16 lg:py-24 space-y-16 grain-bg" data-testid="how-its-made-steps">
          {steps.map((step, idx) => (
            <div key={idx} className="grid lg:grid-cols-[120px_1fr] gap-6 lg:gap-12 animate-fade-up">
              <div className="font-serif text-6xl lg:text-7xl text-primary/30 leading-none">{step.n}</div>
              <div>
                <h2 className="font-serif text-3xl lg:text-4xl text-foreground mb-4">{step.title}</h2>
                <p className="text-foreground/80 text-lg leading-relaxed">{step.body}</p>
                <div className="mt-8 wood-divider" />
              </div>
            </div>
          ))}
        </section>
      </article>
    </>
  );
}
